import React, { useState } from "react";
import styled from "styled-components";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";

import Button from "../shared/Button";
import UploadInformationStandaloneForm from "../estates/UploadInformationStandaloneForm";

import { find, get, map } from "lodash";
import { Checkbox, TextField, Tooltip } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const FileItem = ({
  file,
  uuid,
  filename,
  size,
  effectiveDate,
  documentType,
  association,
  onChangeAssociation,
  onRemove,
  onEdit,
  extension,
  estateId,
  isModalView = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const hasAssociation = Boolean(association && association.length);

  return (
    <StyleWrapper direction="row" justifyContent="space-between">
      <Stack
        direction="row"
        alignItems="center"
        sx={{ flexGrow: 1, minWidth: 0 }}
      >
        <img
          className="upload-file-icon"
          src="/assets/icons/file-item.svg"
          alt=""
        />
        <Stack sx={{ minWidth: 0 }}>
          <div className="filename">
            <Tooltip title={`${filename}${extension}`}>
              <Typography
                className="text-ellipsis"
                color="var(--text-color)"
                fontSize={14}
                fontWeight={400}
              >
                {filename}
                {extension}
              </Typography>
            </Tooltip>
          </div>
          <Typography color="#0F91D2" fontSize={10} fontWeight={400}>
            Preview - {size} Mo
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="end"
        sx={{ flexShrink: 0 }}
      >
        {!isModalView && (
          <>
            <Box width={300}>
              <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                limitTags={1}
                value={map(association, (e) => e.id)}
                options={map(association, (e) => e.id)}
                onChange={(_event, items) =>
                  onChangeAssociation(
                    map(items, (estateId) =>
                      find(association, ({ id }) => id === estateId)
                    )
                  )
                }
                getOptionLabel={(option) =>
                  get(
                    find(association, ({ id }) => id === option),
                    "name",
                    ""
                  )
                }
                renderInput={(params) => <TextField {...params} />}
                renderOption={(props, _option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={
                          <CheckBoxIcon
                            fontSize="small"
                            htmlColor="var(--red-color)"
                          />
                        }
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {key}
                    </li>
                  );
                }}
              />
            </Box>
            <div className="info">
              <p className="info-label">Date de publication</p>
              <p className="info-value">{effectiveDate || "-"}</p>
            </div>
            <div className="info">
              <p className="info-label">Type de document</p>
              <p className="info-value">{documentType || "-"}</p>
            </div>
            <Button
              size="small"
              className="process-btn"
              color={hasAssociation ? "success" : "primary"}
              variant="contained"
              icon={
                <img
                  src={`/assets/icons/doc-${
                    hasAssociation ? "" : "not-"
                  }processed.svg`}
                  alt=""
                />
              }
              onClick={onEdit}
            >
              {hasAssociation ? "Document traité" : "Asssocier"}
            </Button>
          </>
        )}
        {isModalView && (
          <Box sx={{ width: 700 }}>
            <UploadInformationStandaloneForm file={file} estateId={estateId} />
          </Box>
        )}
        <IconButton
          id={`basic-button-${uuid}`}
          aria-controls={open ? `basic-menu-${uuid}` : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id={`basic-menu-${uuid}`}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": `basic-button-${uuid}`,
            },
          }}
        >
          {hasAssociation && <MenuItem onClick={onEdit}>Modifier</MenuItem>}
          <MenuItem onClick={onRemove}>Supprimer</MenuItem>
        </Menu>
      </Stack>
    </StyleWrapper>
  );
};

const StyleWrapper = styled(Stack)`
  background-color: var(--white);
  box-shadow: 0px 0px 6px 0px #0000000d;
  height: 80px;
  border-radius: 6px;
  padding-left: 20px;

  .info {
    flex-shrink: 0;
    padding: 0 40px;

    &:first-child {
      border-right: 1px solid var(--border-color);
    }
  }

  button.process-btn {
    width: 182px;
    font-weight: 400;
    flex-shrink: 0;
    margin-left: 40px;

    img {
      margin-right: 5px;
    }
  }

  .info-label {
    color: var(--blue-dark);
    font-size: 10px;
    font-weight: 400;
    margin-bottom: 0;
  }

  .info-value {
    color: var(--text-color);
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 0;
  }

  .upload-file-icon {
    height: 20px;
    width: 16px;
    margin-right: 10px;
  }

  .filename {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    max-width: 220px;
  }
`;

export default FileItem;
